import { FC } from "react";
import { useTranslation } from "react-i18next";

const ServiceOutageNotice: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="p-8">
      <h5 className="pt-5 pb-5 text-success">{t("notice_down.title")}</h5>
      <p>{t("notice_down.description")}</p>
      <h5 className="pt-5 pb-5 text-success">
        {t("notice_down.what_happens")}
      </h5>
      <p className="subtitle pb-2">{t("notice_down.voices_call_title")}</p>
      <p>{t("notice_down.voices_call_description")}</p>
      <p className="subtitle pb-1 pt-4">{t("notice_down.chat_title")}</p>
      <p>{t("notice_down.chat_description")}</p>

      <p className="subtitle pb-1 pt-4">{t("notice_down.sms_email_title")}</p>
      <p>{t("notice_down.sms_email_description")}</p>
      <p className="pt-6">{t("notice_down.foot_note")}</p>
      <p className="pt-6">{t("notice_down.foot_note_line2")}</p>
    </div>
  );
};

export default ServiceOutageNotice;
